<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- 교육내용 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>교육구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <custom-option-selector v-else :readonly="board.readonly" v-model="form.inputA_1" :options="diff" @change="changeTarget1" />
        </div>
        <div v-if="getDiff.length > 0" class="writeGridLineItem">
          <div>대상(작업명)</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.inputA_2"
            :options="getDiff"
            placeholder="1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)"
            @change="changeTarget2"
          />
        </div>
        <div>
          <div>교육명</div>
          <vs-input v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육일</div>
          <date-selector v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육시간</div>
          <div class="time">
            <time-selector v-model="form.inputA_5" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.inputA_6" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>교육장소</div>
          <vs-input v-model="form.inputA_7" :readonly="board.readonly" />
        </div>

        <div>
          <div>교육내용에 반영한 재해형태(필수)</div>
          <disaster-class-selector :multiple="true" :readonly="board.readonly" v-model="form.inputA_8" @input="inputDisaster" />
        </div>

        <div>
          <div>교육 실시자 성명</div>
          <vs-input v-model="form.inputA_9" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육 실시자 소속</div>
          <vs-input v-model="form.inputA_10" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육 실시자 직책</div>
          <vs-input v-model="form.inputA_11" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육 대상</div>
          <vs-input v-model="form.inputA_12" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육 실시 인원</div>
          <comma-input v-model="form.inputA_13" type="number" :readonly="board.readonly" />
          <p>명</p>
        </div>
        <div>
          <div>교육 미실시 인원</div>
          <comma-input v-model="form.inputA_14" type="number" :readonly="board.readonly" />
          <p>명</p>
        </div>
        <div class="writeGridLineItem">
          <div>교육내용</div>
          <vs-textarea rows="5" v-model="form.inputA_15" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>근로자 의견</div>
          <vs-textarea rows="5" v-model="form.inputA_16" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 참석자 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        { id: 'target', title: '소속명', type: 'text', placeholder: '' },
        { id: 'class', title: '직종', type: 'text', placeholder: '' },
        { id: 'name', title: '이름', type: 'text', placeholder: '' },
        { id: 'sign', title: '서명', type: 'sign', placeholder: '' },
        { id: 'note', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.signatureList"
      class="mt-4"
    />

    <!-- 확인자 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 확인자</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer">
        <div>
          <div>안전관리자</div>
          <vs-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
        <div class="hidden xl:block"></div>
        <div>
          <div>관리책임자</div>
          <vs-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="교육 사진" placeholder="신축현장 점검" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <vs-popup id="popupReportList" title="안전보건 교육일지" :active.sync="showPopup">
      <div class="w-full flex flex-row justify-between items-center gap-4 p-6">
        <div class="flex-1 flex flex-row items-center gap-4">
          <search-nav-start-end label="작성일" v-model="search.date" />
          <search-nav-item-select label="발생형태" v-model="search.disasterType" :list="disasterTypes" />
          <search-nav-item-select :label="$t('search.검색조건')" v-model="search.searchType" :list="searchTypes" />
          <search-nav-item-keyword :label="$t('search.키워드')" v-model="search.searchKeyword" />
        </div>
        <vs-button color="secondary" @click="handleClickSearch"> 검색 </vs-button>
      </div>
      <vs-table stripe ref="table" :sst="true" :max-items="page.perPage" :data="reportList" noDataText="데이터가 없습니다">
        <template slot="thead">
          <vs-th class="w-1/12" style="min-width: 100px"> No. </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 현장명 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 구분 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 교육일 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 재해형태 </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 교익 실시 인원(명) </vs-th>
          <vs-th class="w-1/12" style="min-width: 100px"> 작성일 </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, index) in data" :key="index" class="cursor-pointer" @click.native="() => handleItemClickDetail(item)">
            <vs-td>{{ item.id }}</vs-td>
            <vs-td>{{ item.stdInfo.field_name }}</vs-td>
            <vs-td>{{ item.inputA_1 && item.inputA_1.value }}</vs-td>
            <vs-td>{{ item.inputA_3 }}</vs-td>
            <vs-td>{{ item.inputA_6 }}</vs-td>
            <vs-td>{{ item.inputA_11 }}</vs-td>
            <vs-td>{{ item.stdInfo.date }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="vs-con-table mb-6">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="page.lastPage ? page.lastPage : 1" :value="page.current" @change="handleChangePage" />
        </div>
      </div>
    </vs-popup>
  </div>
  <print107 v-else :form="form" :board="board" />
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Print107 from "./Print";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/views/list/components/SearchNavStartEnd";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { valueDisasters } from "@/util/DisasterDataUtil";

import TableCustom from "@/components/TableCustom.vue";

import diffData from "./DiffData";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    Print107,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      showPopup: false,
      disasterTypes: [{ text: "전체선택", value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: "현장명" },
        { value: "inputD_1", text: "재해일시" },
        { value: "inputD_3", text: "발생형태" },
        { value: "stdInfo.department", text: "소속명" },
        { value: "stdInfo.com_name", text: "부서명" },
        { value: "stdInfo.writer_name", text: "작성자" },
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // =============== FORM ===============
      diff: diffData,
      form: {
        stdInfo: {},

        inputA_1: null,
        inputA_2: null,

        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: [],
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",
        inputA_13: "",
        inputA_14: "",
        inputA_15: "",
        inputA_16: "",

        photoList: [],
        fileList: [],
        signatureList: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        disasters: "",
      },
    };
  },
  computed: {
    reportList() {
      if (!!this.$store.state.board.postListInfo.data) {
        return this.$store.state.board.postListInfo.data.map((item) => {
          return { id: item.id, ...this.getContent(item).body };
        });
      } else return [];
    },

    getDiff() {
      if (this.form.inputA_1) {
        if (this.diff[this.form.inputA_1.index].child.length === 1) {
          if (this.diff[this.form.inputA_1.index].child[0].value === "-") {
            return [];
          } else {
            return this.diff[this.form.inputA_1.index].child;
          }
        } else {
          return this.diff[this.form.inputA_1.index].child;
        }
      } else {
        return [];
      }
    },
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          안전보건교육_현장명: [],
          안전보건교육_재해형태: [],
          안전보건교육_교육구분: [],
          안전보건교육_현장별교육구분: [],
          안전보건교육_현장별재해형태: [],
        };

        value.summary["안전보건교육_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["안전보건교육_재해형태"].push({
          [this.form.inputB_6]: 1,
        });

        value.summary["안전보건교육_교육구분"].push({
          [this.form.inputB_1]: 1,
        });

        value.summary["안전보건교육_현장별교육구분"].push({
          [`${this.form.stdInfo.field_name}_${this.form.inputB_1}`]: 1,
        });

        value.summary["안전보건교육_현장별재해형태"].push({
          [`${this.form.stdInfo.field_name}_${this.form.inputB_6}`]: 1,
        });

        this.$emit("input", value);
      },
      board: {
        immediate: true,
        deep: true,
        handler(value) {
          if (!this.isMounted) return;
          if (!this.board.readonly && !this.customButton) {
            /** 이전 문서 불러오기 버튼 추가 */
            this.customButton = document.createElement("button");
            this.customButton.className = "vs-component vs-button ml-4 vs-button-secondary vs-button-border";
            this.customButton.innerText = "이전 문서 불러오기";
            this.customButton.addEventListener("click", this.onClickLoadBtn);

            const btnsContainer = document.getElementById("right-button-container");
            btnsContainer.insertAdjacentElement("afterbegin", this.customButton);
          } else if (this.board.readonly && !!this.customButton) {
            this.customButton.remove();
          }
        },
      },
    },
  },
  mounted() {
    this.isMounted = true;
  },
  destroyed() {
    if (!!this.customButton) this.customButton.removeEventListener("click", this.onClickLoadBtn);
  },
  methods: {
    // ======================= 이전 문서 불러오기 =======================
    onClickLoadBtn() {
      this.loadReport();
      this.showPopup = true;
    },
    handleClickSearch() {
      this.page.current = 1;
      this.loadReport();
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadReport();
    },
    async loadReport() {
      const boardId = 107;
      const projectId = this.$route.params.proj_id;
      const page = this.page.current;
      const perPage = this.page.perPage;

      const { date, disasterType, searchType, searchKeyword } = this.search;
      let keyword = [];
      if (!!disasterType) keyword.push(`content$body.inputD_3*${disasterType}`);
      if (!!searchType && !!searchKeyword) keyword.push(`content$body.${searchType}*%${searchKeyword}%`);

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        dateBegin: date.sDate,
        dateEnd: date.eDate,
        keyword: keyword,
      });

      const data = this.$store.state.board.postListInfo;
      this.page.current = data.current_page;
      this.page.lastPage = data.last_page;
    },
    handleItemClickDetail(data) {
      this.form.inputA_1 = data.inputA_1;
      this.form.inputA_2 = data.inputA_2;
      this.form.inputA_3 = data.inputA_3;
      this.form.inputA_4 = data.inputA_4;
      this.form.inputA_5 = data.inputA_5;
      this.form.inputA_6 = data.inputA_6;
      this.form.inputA_7 = data.inputA_7;
      this.form.inputA_8 = data.inputA_8;
      this.form.inputA_9 = data.inputA_9;
      this.form.inputA_10 = data.inputA_10;
      this.form.inputA_11 = data.inputA_11;
      this.form.inputA_12 = data.inputA_12;
      this.form.inputA_13 = data.inputA_13;
      this.form.inputA_14 = data.inputA_14;
      this.form.inputA_15 = data.inputA_15;
      this.form.inputA_16 = data.inputA_16;

      this.form.photoList = data.photoList;
      this.form.fileList = data.fileList;
      this.form.signatureList = data.signatureList;

      this.showPopup = false;
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content;
      }
    },
    // ======================= FORM =======================
    changeTarget1() {
      if (!this.form.inputA_1) return;
      this.form.inputA_2 = { ...this.diff[this.form.inputA_1.index].child[0], index: 0 };
      if (!!this.form.inputA_1 && !!this.form.inputA_2) this.form.inputA_15 = this.diff[this.form.inputA_1.index].child[this.form.inputA_2.index].textarea;
    },
    changeTarget2() {
      if (!!this.form.inputA_1 && !!this.form.inputA_2) this.form.inputA_15 = this.diff[this.form.inputA_1.index].child[this.form.inputA_2.index].textarea;
    },
    inputDisaster(field) {
      const disasters = field;
      this.form.disasters = "";
      for (const disaster of disasters) {
        this.form.disasters += `${disaster} `;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

#popupReportList::v-deep > .vs-popup {
  width: 90vw !important;
}
</style>
